import { AccountType } from '@/common/types'
import { MobileBottomNav } from './MobileBottomNav'
import { getMobileBottomNavItems } from './mobileNavConfig'
import { useFeatureFlags } from '../featureFlags/featureFlags'
import { usePrimaryAccount } from '@/account/usePrimaryAccount'

export function UnifiedMobileBottomNav() {
    const featureFlags = useFeatureFlags()
    const primaryAccount = usePrimaryAccount()
    const isAdviserUser = primaryAccount?.accountType === AccountType.ADVISER
    const items = getMobileBottomNavItems(isAdviserUser, featureFlags)

    return <MobileBottomNav items={items} />
}
